import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { EnterpriseFailureHandlerFailureCount } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const fetchFailureCountOverview = () => EnterpriseFailureHandlerFailureCount.count();
const useFailuresOverview = () => {
  const { data, refetch, isLoading, error, isSuccess } = useQuery({
    queryKey: ["failures", "counts"],
    queryFn: () => defaultOnError(
      fetchFailureCountOverview(),
      i18n.t("notifications.failure_counts_loading_failed", { ns: "enterprise_data_tiering" }),
      i18n.t("notifications.failure_counts_could_not_load", { ns: "enterprise_data_tiering" })
    ),
    notifyOnChangeProps: ["data", "error"]
  });
  return {
    data,
    refetch,
    isLoading,
    error,
    isSuccess
  };
};
export default useFailuresOverview;
